import { useAuth } from "../context/AuthContext";
import MainLayout from "../layout/MainLayout";
import ExecutiveBoard from "../components/executive/ExecutiveBoard";

/** Главная: приветствие + настраиваемый планшет руководителя (правка №41; задачи — окно «Задачи на сегодня»). */
export default function Dashboard() {
    const { user } = useAuth();
    return (
        <MainLayout>
            <div className="mb-3 flex items-baseline gap-3 flex-wrap">
                <h1 className="text-2xl font-bold tracking-tight text-slate-900">С возвращением, {user?.name}!</h1>
                <p className="text-sm text-slate-500">Что происходит с наймом, вакансиями и адаптацией прямо сейчас.</p>
            </div>
            <ExecutiveBoard />
        </MainLayout>
    );
}
